import { useLayoutEffect, useRef, useState } from "react";
import IconLink from "../common/IconLink";

import { useTranslation } from '../../i18n/LanguageProvider';

// Exported so the feed is generated from the same list the page renders.
export const newsData = [
  {
    date: "Sep 2026",
    content: (
      <>
        Won the Best PhD Thesis award at <a href="/publications/2026-ctd">SBSeg 2026</a>.
      </>
    ),
    contentPt: <>Ganhei o prêmio de melhor tese de doutorado no <a href="/publications/2026-ctd">SBSeg 2026</a>.</>,
  },
  {
    date: "Aug 2026",
    content: (
      <>
        <a href="https://www.foxit.com/" target="_blank" rel="noopener noreferrer">Foxit</a> published <a href="https://www.cve.org/CVERecord?id=CVE-2026-18622" target="_blank" rel="noopener noreferrer">CVE-2026-18622</a> for <a href="https://www.foxit.com/pdf-editor/" target="_blank" rel="noopener noreferrer">Foxit PDF Editor</a> and <a href="https://www.foxit.com/pdf-reader/" target="_blank" rel="noopener noreferrer">Foxit PDF Reader</a> after we disclosed the attacks from our paper <a href="/publications/2026-sbseg-yacht-sale">$1 Yacht Sale</a>.
      </>
    ),
    contentPt: <>A <a href="https://www.foxit.com/" target="_blank" rel="noopener noreferrer">Foxit</a> publicou a <a href="https://www.cve.org/CVERecord?id=CVE-2026-18622" target="_blank" rel="noopener noreferrer">CVE-2026-18622</a> para o <a href="https://www.foxit.com/pdf-editor/" target="_blank" rel="noopener noreferrer">Foxit PDF Editor</a> e o <a href="https://www.foxit.com/pdf-reader/" target="_blank" rel="noopener noreferrer">Foxit PDF Reader</a> depois que reportamos os ataques do nosso artigo <a href="/publications/2026-sbseg-yacht-sale">$1 Yacht Sale</a>.</>,
  },
  {
    date: "Jul 2026",
    content: (
      <>
        After nearly a decade at IFRS, <a href="https://www.instagram.com/p/DbBqYgyoGp1/?img_index=3">I joined</a> the Federal University of Santa Catarina.
      </>
    ),
    contentPt: <>Depois de quase uma década no IFRS, <a href="https://www.instagram.com/p/DbBqYgyoGp1/?img_index=3">ingressei</a> na Universidade Federal de Santa Catarina.</>,
  },
  {
    date: "Mar 2026",
    content: (
      <>
        Invited by <a href="https://www.cesar.org.br/ciberseguranca" target="_blank" rel="noopener noreferrer">CESAR</a> to co-lead a research project on <a href="/projects">IAM for intelligent agents across domains</a>.
      </>
    ),
    contentPt: <>Fui convidado pelo <a href="https://www.cesar.org.br/ciberseguranca" target="_blank" rel="noopener noreferrer">CESAR</a> para co-liderar um projeto de pesquisa sobre <a href="/projects">gestão de identidade e acesso para agentes inteligentes entre domínios</a>.</>,
  },
  {
    date: "Nov 2025",
    content: (
      <>
        Invited by <a href="https://rnp.br/" target="_blank" rel="noopener noreferrer">RNP</a> to contribute to a <a href="https://web.archive.org/web/20251228041547/https://www.rnp.br/noticias/workshop-promove-discussao-sobre-roadmap-estrategico-em-gestao-de-identidade-digital-para-o-sistema-rnp/" target="_blank" rel="noopener noreferrer">strategic roadmap workshop</a> on IAM.
      </>
    ),
    contentPt: <>Fui convidado pela <a href="https://rnp.br/" target="_blank" rel="noopener noreferrer">RNP</a> para contribuir com um <a href="https://web.archive.org/web/20251228041547/https://www.rnp.br/noticias/workshop-promove-discussao-sobre-roadmap-estrategico-em-gestao-de-identidade-digital-para-o-sistema-rnp/" target="_blank" rel="noopener noreferrer">workshop sobre um roadmap estratégico</a> de gestão de identidade e acesso.</>,
  },
  {
    date: "Oct 2025",
    content: (
      <>
        Attended the <a href="https://internetidentityworkshop.com/" target="_blank" rel="noopener noreferrer">41st Internet Identity Workshop (IIW)</a> and hosted a <a href="/talks/2025-iiw">session on OIDC4AC</a>.
      </>
    ),
    contentPt: <>Participei do <a href="https://internetidentityworkshop.com/" target="_blank" rel="noopener noreferrer">41º Internet Identity Workshop (IIW)</a> e conduzi uma <a href="/talks/2025-iiw">sessão sobre OIDC4AC</a>.</>,
  },
  {
    date: "Sep 2025",
    content: (
      <>
        Hosted the <a href="https://web.archive.org/web/20250912162731/https://sbseg2025.ppgia.pucpr.br/en/call-for-papers/wgid/" target="_blank" rel="noopener noreferrer">XV Workshop on Digital Identity Management</a> with <a href="https://emersonmello.me/" target="_blank" rel="noopener noreferrer">Prof. Dr. Emerson Mello</a>.
      </>
    ),
    contentPt: <>Organizei o <a href="https://web.archive.org/web/20250912162731/https://sbseg2025.ppgia.pucpr.br/en/call-for-papers/wgid/" target="_blank" rel="noopener noreferrer">XV Workshop de Gestão de Identidades Digitais</a> com o <a href="https://emersonmello.me/" target="_blank" rel="noopener noreferrer">Prof. Dr. Emerson Mello</a>.</>,
  },
  {
    date: "May 2025",
    content: (
      <>
        My PhD thesis was <a target="_blank" rel="noopener noreferrer" href="https://web.archive.org/web/20250517002846/https://ppgcc.ufsc.br/2025/05/14/resultado-da-selecao-da-tese-escolhida-para-concorrer-ao-premio-capes-de-teses-2025-edital-n-062025capes/">selected to represent the graduate program</a> for a <a target="_blank" rel="noopener noreferrer" href="https://web.archive.org/web/20250517005759/https://www.gov.br/capes/pt-br/assuntos/premios/premio-capes-de-tese/premio-capes-de-tese-documentos-relacionados">national award</a>.
      </>
    ),
    contentPt: <>Minha tese de doutorado foi <a target="_blank" rel="noopener noreferrer" href="https://web.archive.org/web/20250517002846/https://ppgcc.ufsc.br/2025/05/14/resultado-da-selecao-da-tese-escolhida-para-concorrer-ao-premio-capes-de-teses-2025-edital-n-062025capes/">selecionada para representar o programa de pós-graduação</a> em um <a target="_blank" rel="noopener noreferrer" href="https://web.archive.org/web/20250517005759/https://www.gov.br/capes/pt-br/assuntos/premios/premio-capes-de-tese/premio-capes-de-tese-documentos-relacionados">prêmio nacional</a>.</>,
  },
  {
    date: "Apr 2025",
    content: (
      <>
        Our GT-BAITA proposal <a target="_blank" rel="noopener noreferrer" href="https://web.archive.org/web/20250516234949/https://www.rnp.br/rnp-divulga-resultado-da-chamada-de-pdi-servicos-avancados-2025/">has been accepted by RNP's 2025 Working Groups</a>.
      </>
    ),
    contentPt: <>Nossa proposta do GT-BAITA <a target="_blank" rel="noopener noreferrer" href="https://web.archive.org/web/20250516234949/https://www.rnp.br/rnp-divulga-resultado-da-chamada-de-pdi-servicos-avancados-2025/">foi aceita pelos Grupos de Trabalho da RNP de 2025</a>.</>,
  },
  {
    date: "Mar 2025",
    content: "Organized and delivered a two-week PKI and eID course for Mozambique's CEDSIF and INTIC.",
    contentPt: "Organizei e ministrei um curso de duas semanas sobre ICP e identidade eletrônica para o CEDSIF e o INTIC, de Moçambique.",
  },
  {
    date: "Dec 2024",
    content: "This website is released.",
    contentPt: "Este site foi lançado.",
  },
  {
    date: "Nov 2024",
    content: (
      <>
        <a href="/projects#ades">We</a> received the <a href="https://web.archive.org/web/20241205084853/https://noticias.ufsc.br/2024/11/premio-inova-ufsc-celebra-trabalhos-e-agentes-de-inovacao-da-universidade/" target="_blank" rel="noopener noreferrer">Inova UFSC Award</a>.
      </>
    ),
    contentPt: <><a href="/projects#ades">Recebemos</a> o <a href="https://web.archive.org/web/20241205084853/https://noticias.ufsc.br/2024/11/premio-inova-ufsc-celebra-trabalhos-e-agentes-de-inovacao-da-universidade/" target="_blank" rel="noopener noreferrer">Prêmio Inova UFSC</a>.</>,
  },
  {
    date: "Nov 2024",
    content: (
      <>
        Invited by <a href="https://rnp.br/" target="_blank" rel="noopener noreferrer">RNP</a> to contribute to a <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/posts/redernp_recentemente-diversos-especialistas-da-rnp-activity-7270144890234171392-_BGX/">workshop</a> on decentralized digital identity.
      </>
    ),
    contentPt: <>Fui convidado pela <a href="https://rnp.br/" target="_blank" rel="noopener noreferrer">RNP</a> para contribuir com um <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/posts/redernp_recentemente-diversos-especialistas-da-rnp-activity-7270144890234171392-_BGX/">workshop</a> sobre identidade digital descentralizada.</>,
  },
  {
    date: "Sep 2024",
    content: (
      <>
        Brazilian Government <a href="https://web.archive.org/web/20241223181957/https://ifrs.edu.br/rolante/professor-do-ifrs-campus-rolante-participa-de-missao-oficial-em-mocambique-a-convite-de-agencia-vinculada-ao-ministerio-das-relacoes-exteriores/" target="_blank" rel="noopener noreferrer">Official Mission to Mozambique</a>.
      </>
    ),
    contentPt: <>Participei da <a href="https://web.archive.org/web/20241223181957/https://ifrs.edu.br/rolante/professor-do-ifrs-campus-rolante-participa-de-missao-oficial-em-mocambique-a-convite-de-agencia-vinculada-ao-ministerio-das-relacoes-exteriores/" target="_blank" rel="noopener noreferrer">Missão Oficial do Governo Brasileiro</a> a Moçambique.</>,
  },
  {
    date: "Aug 2024",
    content: (
      <>
        Received the <a href="https://web.archive.org/web/20240821003415/https://digitalidadvancement.org/news/celebrating-excellence-meet-the-first-vittorio-bertocci-award-winners/" target="_blank" rel="noopener noreferrer">Vittorio Bertocci Award</a>.
      </>
    ),
    contentPt: <>Recebi o <a href="https://web.archive.org/web/20240821003415/https://digitalidadvancement.org/news/celebrating-excellence-meet-the-first-vittorio-bertocci-award-winners/" target="_blank" rel="noopener noreferrer">Vittorio Bertocci Award</a>.</>,
  },
  {
    date: "Jul 2024",
    content: (
      <>
        I successfully defended my PhD thesis!
        <IconLink className="p-1" href="https://www.youtube.com/live/3tDDqp-bI7s"
          label="Watch it on YouTube (Portuguese language)">
          <i className="icon-youtube"></i>
        </IconLink>
      </>
    ),
    contentPt: <>Defendi minha tese de doutorado com sucesso! <IconLink className="p-1" href="https://www.youtube.com/live/3tDDqp-bI7s" label="Assista no YouTube (em português)"><i className="icon-youtube"></i></IconLink></>,
  },
  {
    date: "Sep 2022",
    content: (
      <>
        Forbes <a href="https://web.archive.org/web/20241223161239/https://www.forbes.com/councils/forbestechcouncil/2022/09/26/self-sovereign-identity-taking-control-over-your-digital-identity/" target="_blank" rel="noopener noreferrer">mention</a>.
      </>
    ),
    contentPt: <>Menção na <a href="https://web.archive.org/web/20241223161239/https://www.forbes.com/councils/forbestechcouncil/2022/09/26/self-sovereign-identity-taking-control-over-your-digital-identity/" target="_blank" rel="noopener noreferrer">Forbes</a>.</>,
  },
  {
    date: "Apr 2022",
    content: (
      <>
        Received the <a href="https://web.archive.org/web/20240724064435/https://openid.net/2022-openid-foundation-kim-cameron-award-recipients-announced/" target="_blank" rel="noopener noreferrer">Kim Cameron Award</a>.
      </>
    ),
    contentPt: <>Recebi o <a href="https://web.archive.org/web/20240724064435/https://openid.net/2022-openid-foundation-kim-cameron-award-recipients-announced/" target="_blank" rel="noopener noreferrer">Kim Cameron Award</a>.</>,
  },

  
];

const NewsRow = ({ news }) => (
  <tr data-news-row="">
    <td align="right" style={{ whiteSpace: "nowrap", width: "50px" }}>
      {news.date}
    </td>
    <td align="left">{news.content}</td>
  </tr>
);

// Below this width the layout is a single column, so there is no facing column to measure
// against and the news falls back to a short list behind the toggle.
const TWO_COLUMN_WIDTH = 992;
const FALLBACK_VISIBLE = 3;

// How many entries fit beside the main column without making the page taller than it already
// is. The main column's own content sets the budget, so growing the news list never feeds back
// into the measurement.
function fitCount(card, mainColumn, profile) {
  if (!card || !mainColumn || !profile) return null;
  if (window.innerWidth < TWO_COLUMN_WIDTH) return FALLBACK_VISIBLE;

  const last = mainColumn.lastElementChild;
  if (!last) return null;
  const available = last.offsetTop + last.offsetHeight - profile.offsetHeight;

  const rows = [...card.querySelectorAll('[data-news-row]')];
  if (!rows.length) return null;

  const rowsHeight = rows.reduce((total, row) => total + row.offsetHeight, 0);
  // No layout information at all: a test environment, or a hidden container. Anything measured
  // here would be arbitrary, so the list is left as it is.
  if (available <= 0 || rowsHeight <= 0) return null;
  const chrome = card.offsetHeight - rowsHeight;
  const toggle = card.querySelector('.news-history')?.offsetHeight || 40;

  let used = chrome;
  for (let index = 0; index < rows.length; index += 1) {
    used += rows[index].offsetHeight;
    // Everything from here on has to hide behind the toggle, which needs room of its own.
    if (used + (index < rows.length - 1 ? toggle : 0) > available) return Math.max(index, 1);
  }

  return rows.length;
}

export default function News({ mainColumnRef, profileRef }) {
  const { isPortuguese, t } = useTranslation();
  const cardRef = useRef(null);
  // Start with the whole list: it is what usually fits, and it is what has to be on screen for
  // the rows to be measurable at all.
  const [visible, setVisible] = useState(newsData.length);

  useLayoutEffect(() => {
    const measure = () => {
      const count = fitCount(cardRef.current, mainColumnRef?.current, profileRef?.current);
      if (count) setVisible(count);
    };

    measure();
    if (typeof ResizeObserver === 'undefined') return undefined;

    const observer = new ResizeObserver(measure);
    [cardRef.current, mainColumnRef?.current, profileRef?.current].forEach(element => {
      if (element) observer.observe(element);
    });
    return () => observer.disconnect();
  }, [mainColumnRef, profileRef, isPortuguese]);

  const localized = news => ({ ...news, content: isPortuguese && news.contentPt ? news.contentPt : news.content });
  const shown = newsData.slice(0, visible);
  const hidden = newsData.slice(visible);

  return (
    <div id="news" className="card mb-4" ref={cardRef}>
      <div className="card-body">
        <h2 className="card-title">{t('home.news')}</h2>
        <table className="table align-middle mb-0 no-background">
          <tbody>
            {shown.map((news, index) => (
              <NewsRow key={index} news={localized(news)} />
            ))}
          </tbody>
        </table>
        {hidden.length > 0 && (
          <details className="news-history">
            <summary>{isPortuguese ? 'Notícias anteriores' : 'Earlier news'}</summary>
            <table className="table align-middle mb-0 no-background">
              <tbody>
                {hidden.map((news, index) => (
                  <NewsRow key={index} news={localized(news)} />
                ))}
              </tbody>
            </table>
          </details>
        )}
      </div>
    </div>
  );
}
